import {
  Button,
  Center,
  CSSProperties,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const styles: { [key: string]: CSSProperties } = {
  root: {
    height: '100vh',
    width: '100vw',
  },
  container: {
    maxWidth: '35%',
  },
  title: {
    fontSize: '10rem',
    fontWeight: 700,
  },
  subTitle: {
    fontSize: '2rem',
  },
};

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Center style={styles.root}>
      <Stack gap={'xl'} style={styles.container}>
        <Title order={1} style={styles.title}>
          {t('NOT_FOUND_PAGE.TITLE')}
        </Title>
        <Title order={2} style={styles.subTitle}>
          {t('NOT_FOUND_PAGE.DESCRIPTION')}
        </Title>
        <Text>{t('NOT_FOUND_PAGE.ERROR_CODE')}</Text>
        <div>
          <Button component={Link} to="/">
            {t('NOT_FOUND_PAGE.BACK')}
          </Button>
        </div>
      </Stack>
    </Center>
  );
};
